import closeIcon from "../../assets/photo/close.svg"
import closeIconBlack from "../../assets/photo/close_black.svg"
import trashIcon from "../../assets/photo/trash.svg"
import trashIconBlack from "../../assets/photo/light_theme/trash.svg"
import phyalbumIcon from "../../assets/photo/physical-album.svg"
import phyalbumIconBlack from "../../assets/photo/light_theme/physical_album.svg"
import downloadIcon from "../../assets/photo/download.svg"
import downloadIconBlack from "../../assets/photo/light_theme/download.svg"
import moveIcon from "../../assets/photo/move.svg"
import moveIconBlack from "../../assets/photo/light_theme/move.svg"
import { MyDispatch, MySelector } from "../../redux/store"
import { useDispatch } from "react-redux"
import { HandleAsyncFns } from "../../hooks/handleAsyncFns"
import {
  resetSelectedPhotos,
  selectAllPhotos,
  setDeleteArray,
  setMoveFolderArray,
  setSelectionMode,
} from "../../redux/utilSlice"
import { Tooltip } from "@mui/material"
import { getDesignLabelClass } from "../../gallery-designs/registry"

const SelectedPhotosNavbar = () => {
  const dispatch = useDispatch<MyDispatch>()
  const {
    selectedPhotos,
    type,
    fullScreen,
    selectionMode,
    currentFolderData,
    downloadData: { downloadEnabled },
  } = MySelector((state) => state.util)

  const { allFiles, activeAlbumFiles } = MySelector((state) => state.gallery)
  const { theme } = MySelector((state) => state.theme)
  const { category, data } = MySelector((state) => state.event)
  // Casing/size follows the active design (e.g. UPPERCASE for editorial).
  const labelClass = getDesignLabelClass(data?.galleryTheme)

  const { downloadFile, moveToPhysicalAlbum } = HandleAsyncFns()

  const modifiedDownloadArray = () => {
    const filteredPhotos = allFiles
      ?.filter((af: any) => selectedPhotos?.includes(af.id))
      ?.map(({ id, url, name, compressedUrl }: { id?: string; url: string; name: string; compressedUrl?: string }) => ({ id, url, name, compressedUrl }))

    downloadFile?.(filteredPhotos)
  }

  return (
    <div
      className={`${
          (selectedPhotos?.length > 0 || selectionMode) && !fullScreen ? "flex" : "hidden"
      } justify-between w-full items-center px-[16px] py-[20.8px] xl:py-[20.5px] sticky top-0 bg-white/85 dark:bg-black/85 z-[5050] ${labelClass}`}
      style={{
        backdropFilter: "blur(12px)",
      }}
    >
      <div className="flex justify-between items-center w-full lg:w-auto lg:block">
        <div className="flex gap-2 items-center justify-between lg:justify-normal">
          <img
            onClick={() => {
              dispatch(resetSelectedPhotos())
              dispatch(setSelectionMode(!selectionMode))
            }}
            className="cursor-pointer w-6 h-6"
            src={theme === "dark" ? closeIcon : closeIconBlack}
            alt=""
          />
          <p className="font-[500] text-newOffBlack dark:text-white">
            {selectedPhotos?.length}{" "}
            <span className="hidden lg:inline">
              {selectedPhotos?.length > 1 ? "photos" : "photo"}
            </span>{" "}
            selected
          </p>
        </div>

        <button
          onClick={() => {
            if (type === "gallery") {
              if (selectedPhotos?.length === currentFolderData?.length)
                dispatch(resetSelectedPhotos())
              else dispatch(selectAllPhotos(currentFolderData))
            } else {
              if (selectedPhotos?.length === activeAlbumFiles?.length)
                dispatch(resetSelectedPhotos())
              else dispatch(selectAllPhotos(activeAlbumFiles || []))
            }
          }}
          className={`font-[500] ${labelClass || "text-sm"} border border-[#F6C67C] rounded-xl py-[6px] px-[14px] text-black goldbg lg:hidden`}
        >
          {type === "gallery"
            ? selectedPhotos?.length === currentFolderData?.length
              ? "Cancel"
              : "Select All"
            : selectedPhotos?.length === activeAlbumFiles?.length
            ? "Cancel"
            : "Select All"}
        </button>
      </div>
      <div className="hidden lg:flex items-center gap-8">
        <div className="flex justify-center items-center gap-7">
          {category === "host" && type === "gallery" && (
            <Tooltip
              title="Move to Folder"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "zIndex",
                    enabled: true,
                    phase: "main",
                    fn: ({ state }) => {
                      state.styles.popper.zIndex = "5060"
                    },
                  },
                ],
              }}
            >
              <img
                src={theme === "dark" ? moveIcon : moveIconBlack}
                alt=""
                onClick={() => dispatch(setMoveFolderArray?.(selectedPhotos))}
                className="h-6 w-6 cursor-pointer"
              />
            </Tooltip>
          )}

          {category === "host" && type === "gallery" && (
            <Tooltip
              title="Move to Physical Album"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "zIndex",
                    enabled: true,
                    phase: "main",
                    fn: ({ state }) => {
                      state.styles.popper.zIndex = "5060"
                    },
                  },
                ],
              }}
            >
              <img
                src={theme === "dark" ? phyalbumIcon : phyalbumIconBlack}
                alt=""
                onClick={() => moveToPhysicalAlbum?.(selectedPhotos)}
                className="h-6 w-6 cursor-pointer"
              />
            </Tooltip>
          )}

          {category === "host" && (
            <Tooltip
              title={type === "gallery" ? "Delete" : "Remove"}
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "zIndex",
                    enabled: true,
                    phase: "main",
                    fn: ({ state }) => {
                      state.styles.popper.zIndex = "5060"
                    },
                  },
                ],
              }}
            >
              <img
                src={theme === "dark" ? trashIcon : trashIconBlack}
                alt=""
                className="h-[21px] w-[21px] cursor-pointer"
                onClick={() => dispatch(setDeleteArray?.(selectedPhotos))}
              />
            </Tooltip>
          )}

          {downloadEnabled && type === "gallery" && (
            <Tooltip
              title="Download"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "zIndex",
                    enabled: true,
                    phase: "main",
                    fn: ({ state }) => {
                      state.styles.popper.zIndex = "5060"
                    },
                  },
                ],
              }}
            >
              <img
                src={theme === "dark" ? downloadIcon : downloadIconBlack}
                alt=""
                onClick={modifiedDownloadArray}
                className="h-[26px] w-[26px] cursor-pointer"
              />
            </Tooltip>
          )}
        </div>

        <button
          onClick={() => {
            if (type === "gallery") {
              if (selectedPhotos?.length === currentFolderData?.length)
                dispatch(resetSelectedPhotos())
              else dispatch(selectAllPhotos(currentFolderData))
            } else {
              if (selectedPhotos?.length === activeAlbumFiles?.length)
                dispatch(resetSelectedPhotos())
              else dispatch(selectAllPhotos(activeAlbumFiles || []))
            }
          }}
          className={`font-[500] ${labelClass || "text-sm"} border border-newDarkBlack dark:border-golden rounded-xl py-[6px] px-[14px] dark:text-black bg-newDarkBlack dark:bg-golden`}
        >
          {type === "gallery"
            ? selectedPhotos?.length === currentFolderData?.length
              ? "Cancel"
              : "Select All"
            : selectedPhotos?.length === activeAlbumFiles?.length
            ? "Cancel"
            : "Select All"}
        </button>
      </div>
    </div>
  )
}

export default SelectedPhotosNavbar
